// extracted by mini-css-extract-plugin
export var aimText = "toprojects-module--aim-text--e3491";
export var aimTxtWrapper = "toprojects-module--aim-txt-wrapper--e8ca5";
export var aimWrapper = "toprojects-module--aim-wrapper--37556";
export var container = "toprojects-module--container--1c9e1";
export var effect = "toprojects-module--effect--82440";
export var text = "toprojects-module--text--b46d4";